var curriculumTabs = [
    {
        id: 'pre-kindergarten',
        text: 'Pre\u2011kindergarten',
        value: 'pre-kindergarten',
        title: 'Pre-kindergarten Grade Math - instruction and mathematics practice for pre-kindergarten grader',
        description: 'Students lay the foundation of number sense and mathematical thinking as they progress through very concrete, hands-on exercises that prepare them for future success in math.',
    },
    {
        id: 'kindergarten',
        text: 'Kindergarten',
        value: 'kindergarten',
        title: 'Kindergarten Grade Math - instruction and mathematics practice for kindergarten grader',
        description: "From number recognition to counting and operations, students build the number sense and conceptual understanding they'll need for grade 1.",
    },
    {
        id: 'grade1',
        text: 'Grade\u00A01',
        value: 'grade1',
        title: 'First Grade Math - instruction and mathematics practice for 1st grader',
        description: 'Students look under the hood of addition and subtraction, applying place value understanding to 2-digit operations.',
    },
    {
        id: 'grade2',
        text: 'Grade\u00A02',
        value: 'grade2',
        title: 'Second Grade Math - instruction and mathematics practice for 2st grader',
        description: 'Students master operations in the hundreds, perform exchanges confidently, and take first steps toward multiplication as they rely on number sense, place value understanding, and number flexibility.',
    },
    {
        id: 'grade3',
        text: 'Grade\u00A03',
        value: 'grade3',
        title: 'Third Grade Math - instruction and mathematics practice for 3rd grader',
        description: "Students' strong foundation of math skills facilitates the shift to multiplication and division, moving from concrete procedures toward abstract thinking and automaticity.",
    },
    {
        id: 'grade4',
        text: 'Grade\u00A04',
        value: 'grade4',
        title: 'Fourth Grade Math - instruction and mathematics practice for 4th grader',
        description: 'As students develop a more abstract understanding of numbers, we stretch their skills in both directions - with multi-digit whole numbers as well as decimals and fractions. Students learn traditional algorithms as well as other approaches that build math flexibility and fluency. In addition to performing operations with these numbers, students learn new ways to measure, convert units, round numbers, and compare numbers. A firm understanding of place value is the common thread running through all topics.',
    },
    {
        id: 'grade5',
        text: 'Grade\u00A05',
        value: 'grade5',
        title: 'Fifth Grade Math - instruction and mathematics practice for 5th grader',
        description: 'Grade Description: Students dig more deeply into place value patterns and operations. Their understanding grows to include decimals in the hundredths and thousandths, operations with fractions and decimals, multi-digit multiplication and division with remainders, area models, properties of multiplication and division, estimation, and measuring volume. We introduce the coordinate plane (quadrant I), which students use to solve problems.',
    },
];
export { curriculumTabs };
